import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import { Badge } from '@/components/ui/daisy';
import { ActivityCorrectionStatusEnum } from '@/models/ActivityProgress';
import { activityCorrectionStatusColors } from '@/utils/activities/activityCorrectionStatusColors';

export type ActivityCorrectionStatusBadgeProps = {
  status: ActivityCorrectionStatusEnum;
  className?: string;
};

export default function ActivityCorrectionStatusBadge({
  status,
  className,
}: ActivityCorrectionStatusBadgeProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'activityCorrectionStatus',
  });

  return (
    <Badge
      size="md"
      variant="soft"
      className={twMerge('truncate', className)}
      color={activityCorrectionStatusColors[status]}
    >
      {t(status)}
    </Badge>
  );
}
